import { render, staticRenderFns } from "./VCompanyEmployees.vue?vue&type=template&id=20b18bc4&lang=pug"
import script from "./VCompanyEmployees.vue?vue&type=script&lang=ts"
export * from "./VCompanyEmployees.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports